<template>
  <div class="w-full relative">
    <transform-position class="w-full"
                        v-model='transform.transform' 
                        :variables='variables'
                        :transform='transform'
                        :partutil='partutil'
                        :holder-data='holderData'
                        :transforms-and-source='transformsAndSource'
                        :selections-data='selectionsData'
                        @instant-edit='onInstantEdit'
                        @instant-add='$emit("instant-add")'
                        @change='onInput'
                        @center='$emit("center")'
                        @add-component='$emit("add-component", $event)'
                        @preview='$emit("preview", $event)'
                        @change-component='onChangeComponent'
                        @go-fullscreen-component-edit='onFullscreenComponentEdit'
                        @edit="$emit('edit', transform)"
                        >
      <template #info=''>
        <slot name='info' />
      </template>
    </transform-position>

    <div class="absolute right-0 top-0 flex flex-row">
      <pbc-button @click='onFullscreenComponentEdit'>
        <fullscreen :size='16' />
      </pbc-button>

      <pbc-button @click='onClose'>
        <close :size='16' />
      </pbc-button>
    </div>
  </div>
</template>
<script>
import Fullscreen from '@icons/Fullscreen.vue';
import Close from '@icons/Close.vue';
import TransformPosition from '@ui/atoms/TransformPosition.vue';
import GameVariables from '@edit/tree/gamevariables.js';
export default {
  props: {
    transform: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    holderData: {
      type: Object,
      required: true
    },
    selectionsData:{
      type: Array,
      required: true
    }
  },
  data() {
    const gameVariables = new GameVariables(this.transformsAndSource.gamedata);
    const variables = gameVariables.getVariablesForTransform(this.transformsAndSource, this.transform);
    return {
      variables
    }
  },
  components: {
    TransformPosition,
    Close,
    Fullscreen
  },
  methods:{
    onFullscreenComponentEdit() {
      console.log('going full-screen');
      this.$emit('edit-components-fullscreen');
    },
    viewComponents() {
      this.$emit('view-components', {
        transform:this.transform
      });
    },
    onInput({type, nv, ov}) {
      const transformId = this.transform.id;
      this.$emit("change", {transformId, type, nv, ov});
    },
    onInstantEdit({component}) {
      console.log('le instant edit', component);
      const transform = this.transform;
      this.$emit('instant-edit', {component,transform});
    },
    onClose() {
      this.$emit("close");
    },
    onChangeComponent() {
      this.$emit('change-components');
    }
  },
  computed: {
    showParentTransformOverlay() {
      return this.childComponent;
    },
  },
  watch:{
    'transform.variables.length'() {
      const gameVariables = new GameVariables(this.transformsAndSource.gamedata);
      this.$set(this, 'variables', gameVariables.getVariablesForTransform(this.transformsAndSource, this.transform));
    },
    'transformsAndSource.from.links.length'(nv,ov) {
      this.$emit('change-components');
    },
  }
}
</script>
